// The Journal: reading progress, the record flip, and the Accidentals player.
(function () {
  document.documentElement.classList.add('j-js');
  var bar = document.querySelector('.j-progress');
  if (bar) {
    var tick = false;
    var update = function () {
      var h = document.documentElement.scrollHeight - innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')'; tick = false;
    };
    addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
  var flips = document.querySelectorAll('.j-flip');
  if ('IntersectionObserver' in window && flips.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: .25 });
    flips.forEach(function (f) { io.observe(f); });
  } else { flips.forEach(function (f) { f.classList.add('is-in'); }); }

  /* ---- Accidentals player: our tracklist drives Spotify's embed (iFrame API). The page keeps the running order,
     because the embed plays one track at a time. Without JS (or before the API loads) every row is a plain Spotify link. */
  var player = document.querySelector('.j-player'); if (!player) return;
  var rows = [].slice.call(document.querySelectorAll('.j-track[data-sp]')).filter(function (r) { return r.dataset.sp; });
  if (!rows.length) return;
  var dock = document.querySelector('.j-dock'), fill = dock.querySelector('.j-dock__fill'), pp = dock.querySelector('.j-dock__pp');
  var ctl = null, cur = -1, paused = true, lastPos = 0, ending = false;
  function show(i) {
    var r = rows[i]; rows.forEach(function (x) { x.classList.toggle('is-playing', x === r); });
    dock.classList.add('is-open'); document.body.classList.add('j-docked');
    dock.querySelector('.j-dock__n').textContent = String(r.dataset.n).padStart(2, '0');
    dock.querySelector('.j-dock__t').textContent = r.querySelector('.j-track__t').textContent;
    dock.querySelector('.j-dock__a').textContent = r.querySelector('.j-track__a').textContent;
  }
  function play(i) {
    if (!ctl || i < 0 || i >= rows.length) return;
    cur = i; ending = false; lastPos = 0; show(i);
    ctl.loadUri('spotify:track:' + rows[i].dataset.sp); ctl.play();
  }
  function byN(n) { for (var k = 0; k < rows.length; k++) if (+rows[k].dataset.n === +n) return k; return -1; }
  window.onSpotifyIframeApiReady = function (API) {
    var host = document.getElementById('j-sp-embed');
    API.createController(host, { uri: 'spotify:playlist:' + player.dataset.playlist, width: '100%', height: 80 }, function (c) {
      ctl = c; document.documentElement.classList.add('j-playable');
      c.addListener('playback_update', function (e) {
        var d = e.data; paused = d.isPaused;
        pp.setAttribute('aria-label', paused ? 'Play' : 'Pause'); dock.classList.toggle('is-paused', paused);
        if (cur >= 0) rows[cur].classList.toggle('is-paused', paused);
        if (d.duration) fill.style.transform = 'scaleX(' + Math.min(1, d.position / d.duration) + ')';
        // a track has finished when it stops within a second of its end: move to the next one, in order
        if (!ending && d.duration && d.position >= d.duration - 1000 && (d.isPaused || d.position === lastPos)) { ending = true; play(cur + 1); }
        lastPos = d.position;
      });
    });
  };
  var s = document.createElement('script'); s.src = 'https://open.spotify.com/embed/iframe-api/v1'; s.async = true; document.head.appendChild(s);
  player.querySelector('.j-player__go').addEventListener('click', function () { play(cur < 0 ? 0 : cur); });
  document.addEventListener('click', function (e) {
    if (!ctl) return;                                                 // not ready: let the Spotify link do its job
    var row = e.target.closest('.j-track__row'), pick = e.target.closest('.j-pick a');
    if (row) { e.preventDefault(); var i = rows.indexOf(row.parentNode); if (i === cur) ctl.togglePlay(); else play(i); }
    else if (pick) { e.preventDefault(); play(byN(pick.parentNode.dataset.n)); }
  });
  dock.querySelector('.j-dock__prev').addEventListener('click', function () { play(Math.max(0, cur - 1)); });
  dock.querySelector('.j-dock__next').addEventListener('click', function () { play(cur + 1); });
  pp.addEventListener('click', function () { if (ctl) ctl.togglePlay(); });
})();
